module.exports = __webpack_public_path__ + "b314986b75f2a81f557544f73e2cd203.svg";